// assets/js/api/graphSearch.js
// import axios from "axios";
import { GRAPH_FACETS } from "../filters/graphFacets";
import { solrFacetsToUi } from "../filters/facetsAdapter";
import { buildFq } from "../filters/fqBuilder";

// export async function searchGraph({ q, filters, extraFq = [], rows = 20, page = 1, sort = "" }) {
//   const start = (Number(page) - 1) * Number(rows);
// 
//   const params = {
//     q: q || "*:*",
//     rows: Number(rows),
//     start,
//     "json.facet": JSON.stringify(GRAPH_FACETS),
//   };
// 
//   const fqFromUi = buildFq(filters || {});
//   const fq = [...(extraFq || []), ...fqFromUi];
//   if (fq.length) params.fq = fq;
// 
//   if (sort) params.sort = sort;
// 
//   const res = await axios.get("/de/jl/api/judaicalink/", { params });
// 
//   return {
//     results: res.data.response?.docs || [],
//     facets: solrFacetsToUi(res.data.facets || {}),
//     total: res.data.response?.numFound || 0,
//   };
// }

export async function searchGraph({ q, filters, extraFq = [], rows = 20, page = 1, sort = "" }) {
  const start = (Number(page) - 1) * Number(rows);

  // 1. Initialize URLSearchParams
  const searchParams = new URLSearchParams({
    q: q || "*:*",
    rows: Number(rows),
    start: start,
    "json.facet": JSON.stringify(GRAPH_FACETS),
  });

  // 2. Handle Arrays (Solr requires multiple 'fq' params)
  const fqFromUi = buildFq(filters || {});
  const fq = [...(extraFq || []), ...fqFromUi];
  
  fq.forEach(filter => {
    searchParams.append("fq", filter);
  });

  // 3. Handle optional sort
  if (sort) {
    searchParams.append("sort", sort);
  }

  // 4. Make the fetch call
  const response = await fetch(`/de/jl/api/judaicalink/?${searchParams.toString()}`);

  // 5. Catch HTTP errors (fetch only throws on network failure)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 6. Parse the JSON body
  const data = await response.json();

  return {
    results: data.response?.docs || [],
    facets: solrFacetsToUi(data.facets || {}),
    total: data.response?.numFound || 0,
  };
}
